import { type OldProductDTO, type OrderDTO, type OrderItemDTO } from 'ecosystem'
import lodashKeyBy from 'lodash/keyBy'
import { getProductWeight } from './products'

type ExtendedOrderItem = OrderItemDTO & { weight: number }

export const calculateOrderTotalWeight = (
  order: OrderDTO,
  fullProducts: OldProductDTO[]
): {
  totalWeight: number
  extendedItems: ExtendedOrderItem[]
} => {
  const dictProducts = lodashKeyBy(fullProducts, 'id')

  return (
    order.items?.reduce<{
      totalWeight: number
      extendedItems: ExtendedOrderItem[]
    }>(
      (acc, item) => {
        const fullProduct = dictProducts[item.product.id]
        let productWeight = 0

        if (fullProduct) {
          productWeight = getProductWeight(fullProduct)
        }

        acc.extendedItems.push({
          ...item,
          weight: productWeight
        })
        acc.totalWeight += productWeight * item.quantity

        return acc
      },
      { totalWeight: 0, extendedItems: [] }
    ) ?? { totalWeight: 0, extendedItems: [] }
  )
}
